import { useAuth } from "@trillion/auth";
import { SignInForm } from "@trillion/ui/components/sign-in-form";
import { Link } from "react-router-dom";

export function LoginPage() {
  const { loginWithPassport } = useAuth();

  return (
    <main className="flex min-h-screen flex-col items-center justify-center gap-4 p-4">
      <SignInForm
        className="min-h-0"
        title="Board"
        description="Sign in with your Trillion Passport account"
        showSsoButton
        onSsoClick={loginWithPassport}
        showLocalForm={false}
        onSubmit={async () => {}}
      />
      <Link
        className="rounded-sm text-sm font-medium text-primary underline-offset-4 hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
        to="/mcp"
      >
        Board MCP setup
      </Link>
    </main>
  );
}
